import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { EmployeeBasicDto } from "../../../../models/dtos/EmployeeBasic.dto";
import { employeeService } from "../../../hrm/services/EmployeeService";

export const useChatUserProfiles = (userIds: Array<string | undefined | null>) => {
  const userIdsKey = useMemo(() => Array.from(new Set(userIds.filter((userId): userId is string => Boolean(userId)))).sort().join("\u0001"), [userIds]);
  const uniqueUserIds = useMemo(() => (userIdsKey ? userIdsKey.split("\u0001") : []), [userIdsKey]);

  const queries = useQueries({
    queries: uniqueUserIds.map((userId) => ({
      queryKey: ["employee-basic", userId],
      queryFn: () => employeeService.getEmployeeBasic(userId),
      enabled: !!userId,
      staleTime: 1000 * 60 * 10,
    })),
  });

  return useMemo(() => {
    const map = new Map<string, EmployeeBasicDto>();

    queries.forEach((query, index) => {
      const userId = uniqueUserIds[index];
      if (userId && query.data) {
        map.set(userId, query.data);
      }
    });

    return map;
  }, [queries, uniqueUserIds]);
};

export const getProfileName = (profile?: EmployeeBasicDto, fallback?: string) => {
  const fullName = profile ? `${profile.lastName} ${profile.firstName}`.trim() : "";
  return fullName || fallback || "User";
};
